import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootState';
import { selectAuth } from '../../store/modules/Auth/selectors';
import UserPageAnnouncementDialog from '../../../shared/components/UserPageAnnouncement/UserPageAnnouncementDialog';

const AutoUserPageAnnouncementDialog = () => {
  const auth = useSelector((state: RootState) => selectAuth(state));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // 認証情報が読み込まれ、ダイアログを表示する必要がある場合
    if (
      auth.loaded &&
      auth.authenticated &&
      auth.userPageAnnouncement?.shouldShow
    ) {
      setOpen(true);
    }
  }, [auth.loaded, auth.authenticated, auth.userPageAnnouncement]);

  const handleClose = () => {
    setOpen(false);
  };

  if (!auth.userPageAnnouncement) {
    return null;
  }

  return (
    <UserPageAnnouncementDialog
      open={open}
      hasExperienceReview={auth.userPageAnnouncement.hasExperienceReview}
      onClose={handleClose}
    />
  );
};

export default AutoUserPageAnnouncementDialog;
